<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import DadosViagem from './compartilhado/FormDadosViagem.vue';
  import Diarias from './compartilhado/FormDiarias.vue';
  import Adiantamento from './compartilhado/FormAdiantamento.vue';
  import Passagens from './compartilhado/FormPassagens.vue';
  import solicitacaoReembolsoServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  
  export default {
    components: { DadosCadastrais, DadosPagamento, DadosViagem, Diarias, Adiantamento, Passagens, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        desabilitarBeneficiario: false,
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        tipos: {
          diaria: false,
          passagem: false,
          adiantamento: false,
        },
        motivos: {
          diaria: '',
          passagem: '',
          adiantamento: '',
        },
        rubricasSubrubricas: {
          diaria: {
            idRubrica: '',
            idSubrubrica: '',
          },
          passagem: {
            idRubrica: '',
            idSubrubrica: '',
          },
          adiantamento: {
            idRubrica: '',
            idSubrubrica: '',
          }
        },
        apenasIda: false,
        configuracao: this.$storage.configuracao(),
        rubricas: [],
        arquivos: [],
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Diária ${ this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' } ${ this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' } Estrangeiro - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-reembolso-estrangeiro.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.documentoTerceiro)
          return false;

        return pessoaServico
          .busca(this.solicitacao.documentoTerceiro)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');
        
        return pessoaServico
          .buscaestrangeiro(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');
            
            this.solicitacao.documentoTerceiro = this.documento; 
            this.solicitacao.nomeTerceiro = pessoa.nomePessoaFisicaJuridica;
            this.solicitacao.endereco = pessoa.endereco ? pessoa.endereco.substring(0, 100) : pessoa.endereco;
            this.solicitacao.numero = pessoa.numero ? pessoa.numero.substring(0, 10) : pessoa.numero;
            this.solicitacao.complemento = pessoa.complemento ? pessoa.complemento.substring(0, 80) : pessoa.complemento;
            this.solicitacao.bairro = pessoa.bairro ? pessoa.bairro.substring(0, 80) : pessoa.bairro;
            this.solicitacao.cidade = pessoa.cidade ? pessoa.cidade.substring(0, 60) : pessoa.cidade;
            this.solicitacao.uf = pessoa.estado;
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.telefoneResidencial = pessoa.telefone1;
            this.solicitacao.telefoneComercial = pessoa.telefone2;
            this.solicitacao.fax = pessoa.fax;
            this.solicitacao.emailTerceiro = pessoa.email;
            this.solicitacao.identidade = pessoa.identidadeInscEstadual;
            this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
            this.solicitacao.pais = pessoa.pais.substring(0, 30);
            
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');

            this.solicitacao.documentoTerceiro = this.documento;
            
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.$events.emit('carregarProjetos');
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolDiariaEstrangeiro || this.$route.params.id) return;

        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolDiariaEstrangeiro.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      validarSePossuiAlgumTipoDeReembolso(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.tipos.passagem || this.tipos.diaria || this.tipos.adiantamento) return true;

        this.$swal(
          '',
          'Selecione algum tipo de reembolso (passagem, diárias e adiantamento)',
          'info'
        );

        throw new Error("validacao");
      },
      validarDataHoraDadosViagem(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        let dataIda = moment(this.solicitacao.dataIda, 'DD/MM/YYYY');
        let dataVolta = this.solicitacao.dataVolta ? moment(this.solicitacao.dataVolta, 'DD/MM/YYYY') : null;
        
        if (this.solicitacao.apenasIda == "false" && !dataIda.isSameOrBefore(dataVolta)) {
          $('#tabs a[href="#tab-dados-viagem"]').tab('show');
          
          this.$swal(
            '',
            'A data de ida deve ser anterior ou igual a data de volta.',
            'info'
          );

          throw new Error("validacao");
        }
        
        /*let horaSaida = moment(`01/01/2000 ${this.solicitacao.horarioIda}`, 'DD/MM/YYYY HH:mm');
        let horaChegada = moment(`01/01/2000 ${this.solicitacao.horarioChegadaIda}`, 'DD/MM/YYYY HH:mm');
        
        if (!horaSaida.isSameOrBefore(horaChegada)) {
          $('#tabs a[href="#tab-dados-viagem"]').tab('show');
          
          this.$swal(
            '',
            'O horário de saída deve ser anterior ou igual ao horário de chegada na Ida.',
            'info'
          );

          throw new Error("validacao");
        } 
        
        horaSaida = moment(`01/01/2000 ${this.solicitacao.horarioVolta}`, 'DD/MM/YYYY HH:mm');
        horaChegada = moment(`01/01/2000 ${this.solicitacao.horarioChegadaVolta}`, 'DD/MM/YYYY HH:mm');
        
        /*if (!horaSaida.isSameOrBefore(horaChegada)) {
          $('#tabs a[href="#tab-dados-viagem"]').tab('show');
          
          this.$swal(
            '',
            'O horário de saída deve ser anterior ou igual ao horário de chegada na Volta',
            'info'
          );

          throw new Error("validacao");
        }*/ 
        
        return valido;
      },
      validarTiposDeReembolso(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        let reembolsos = [];
        
        if (this.tipos.diaria) {
          let validar = this.$refs
            .dadosDiarias
            .validar()
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-diarias"]').tab('show');
              }
              
              return valido;
            });
          
          reembolsos.push(validar);
        }
        if (this.tipos.passagem) {
          let validar = this.$refs
            .dadosPassagens
            .validar()
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-passagens"]').tab('show');
              }

              return valido;
            });
          
          reembolsos.push(validar);
        }
        if (this.tipos.adiantamento) {
          let validar = this.$refs
            .dadosAdiantamento
            .validar()
            .then(valido => {
              if (!valido) {
                $('#tabs a[href="#tab-adiantamento"]').tab('show');
              }

              return valido;
            });

          reembolsos.push(validar);
        }
        
        return Promise.all(reembolsos)
          .then(resultado => {
            return resultado.find(x => x === false) === undefined;
          });
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosPagamento.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosViagem.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-viagem"]').tab('show');
            }

            return valido;
          })
          .then(this.validarDataHoraDadosViagem)
          .then(this.validarSePossuiAlgumTipoDeReembolso)
          .then(this.validarTiposDeReembolso)
          .then(this.enviar)
          .then(retorno => {
            this.$imprimirRelatorio('solicitacao-reembolso-estrangeiro.relatorio', (!!this.$route.params.id ? retorno : retorno[0]), 'solicitacao-reembolso-estrangeiro');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));
        const tipos = JSON.parse(JSON.stringify(this.tipos));
        const motivos = JSON.parse(JSON.stringify(this.motivos));
        const rubricasSubrubricas = JSON.parse(JSON.stringify(this.rubricasSubrubricas));
        
        if (this.$route.params.id) {
          let arquivos = null;
          
          if (this.tipos.diaria) {
            arquivos = this.$refs.adicionarArquivosDiaria.arquivos;
          } else if (this.tipos.passagem) {
            arquivos = this.$refs.adicionarArquivosPassagem.arquivos;
          } else {
            arquivos = this.$refs.adicionarArquivosAdiantamento.arquivos;
          }

          copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
          
          return solicitacaoReembolsoServico.alterar(copiaSolicitacao, tipos,  motivos, rubricasSubrubricas, arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoReembolsoServico.adicionar(
            copiaSolicitacao, tipos, motivos, rubricasSubrubricas, 
            this.$refs.adicionarArquivosDiaria.arquivos, 
            this.$refs.adicionarArquivosPassagem.arquivos, 
            this.$refs.adicionarArquivosAdiantamento.arquivos
          );
        }
      },
      camposSolicitacao() {
        return {
          idCoordenador: null, 
          documentoTerceiro: null, 
          nomeTerceiro: null, 
          observacao: null, 
          agencia: null, 
          banco: null, 
          contaCorrente: null, 
          tipoConta: '', 
          dataNascimento: '', 
          identidade: null, 
          endereco: null, 
          numero: null, 
          complemento: null, 
          bairro: null, 
          cidade: null, 
          cep: null, 
          uf: '', 
          telefoneResidencial: null, 
          telefoneComercial: null, 
          fax: null, 
          formaPagamento: '', 
          dataPagamento: '',  
          origemIda: null, 
          destinoIda: null, 
          dataIda: '', 
          horarioIda: null, 
          origemVolta: null, 
          destinoVolta: null, 
          dataVolta: '', 
          horarioVolta: null, 
          quantidadePassagemIda: null, 
          valorPassagemIda: null, 
          quantidadePassagemVolta: null, 
          valorPassagemVolta: null, 
          valorUnitarioDiaria: null, 
          valorAdiantamento: null, 
          idProjeto: '', 
          idTipoPassagemIda: '', 
          idTipoPassagemVolta: '', 
          idRubrica: '', 
          idSubrubrica: '', 
          quantidadeDiaria: null, 
          idConta: '', 
          emailTerceiro: null, 
          horarioChegadaIda: null, 
          horarioChegadaVolta: null, 
          indicacaoFornecedor: null, 
          quantidadeDiariaNovo: null, 
          valorUnitarioDiariaNovo: null, 
          idDetalheRateio: '', 
          idCategoriaFinanceira: null, 
          idProjetoMetaEtapa: '', 
          apenasIda: 'false', 
          valorTotalKmRodado: null,
          taxaEmbarque: null, 
          taxaEmbarqueNovo: null, 
          diariaCeletista: false, 
          descontoAlimentacao: null, 
          incluiHospedagem: false, 
          despacharBagagem: 0,
          nomeSolicitante: null, 
          emailSolicitante: null, 
          telefoneSolicitante: null,
          idProjetoValorDiaria: '',
          estrangeiro: true,
          pais: '',
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          }
        };
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;
        let idProjeto = null;

        solicitacaoReembolsoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
            idProjeto = solicitacao.idProjeto;
          })
          .then(() => {
            if (this.configuracao.selecaoDeContaWeb) {
              return this.$refs.dadosCadastrais.listaContas(idProjeto);
            }
            
            return true;
          })
          .then(() => {
            if (solicitacao.projeto.utilizarMetaEtapaProjeto) {
              this.$refs.dadosCadastrais.listaDeMetaEtapas(idProjeto)
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
              this.listaDeRubricas(solicitacao.idProjeto);
            }
          })
          .then(() => {
            solicitacao.valorPassagemIda = this.$options.filters.formatarNumero(solicitacao.valorPassagemIda);
            solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataNascimento);
            solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.dataPagamento);
            solicitacao.dataIda = this.$options.filters.formatarNumeroEmData(solicitacao.dataIda);
            solicitacao.dataVolta = this.$options.filters.formatarNumeroEmData(solicitacao.dataVolta);
            
            if (!solicitacao.apenasIda) {
              solicitacao.valorPassagemVolta = this.$options.filters.formatarNumero(solicitacao.valorPassagemVolta);
            }
            
            if (solicitacao.tipoReembolso === 1) {
              solicitacao.quantidadeDiaria = this.$options.filters.formatarNumero(solicitacao.quantidadeDiaria);
              solicitacao.valorUnitarioDiaria = this.$options.filters.formatarNumero(solicitacao.valorUnitarioDiaria);
              solicitacao.taxaEmbarque = solicitacao.taxaEmbarque ? this.$options.filters.formatarNumero(solicitacao.taxaEmbarque) : solicitacao.taxaEmbarque;
              solicitacao.valorTotalKmRodado = solicitacao.valorTotalKmRodado ? this.$options.filters.formatarNumero(solicitacao.valorTotalKmRodado) : solicitacao.valorTotalKmRodado;
              solicitacao.descontoAlimentacao = solicitacao.descontoAlimentacao ? this.$options.filters.formatarNumero(solicitacao.descontoAlimentacao) : solicitacao.descontoAlimentacao;
            } else if (solicitacao.tipoReembolso === 2) {
              solicitacao.valorAdiantamento = this.$options.filters.formatarNumero(solicitacao.valorAdiantamento);
            }
            
            solicitacao.apenasIda = solicitacao.apenasIda.toString();
          })
          .then(() => {
            if (solicitacao.tipoReembolso === 0) {
              this.$set(this.motivos, 'passagem', solicitacao.motivoAdiantamento);
              this.$set(this.tipos, 'passagem', true);
            } else if (solicitacao.tipoReembolso === 1) {
              this.$set(this.motivos, 'diaria', solicitacao.motivoAdiantamento);
              this.$set(this.tipos, 'diaria', true);
            } else {
              this.$set(this.motivos, 'adiantamento', solicitacao.motivoAdiantamento);
              this.$set(this.tipos, 'adiantamento', true);
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
              if (solicitacao.tipoReembolso === 0) {
                this.$set(this.rubricasSubrubricas.passagem, 'idRubrica', solicitacao.idRubrica);
              } else if (solicitacao.tipoReembolso === 1) {
                this.$set(this.rubricasSubrubricas.diaria, 'idRubrica', solicitacao.idRubrica);
              } else {
                this.$set(this.rubricasSubrubricas.adiantamento, 'idRubrica', solicitacao.idRubrica);
              }
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
              if (solicitacao.tipoReembolso === 0) {
                return this.$refs.dadosPassagens.listaDeSubrubricas(solicitacao.idProjeto, solicitacao.idRubrica);
              } else if (solicitacao.tipoReembolso === 1) {
                return this.$refs.dadosDiarias.listaDeSubrubricas(solicitacao.idProjeto, solicitacao.idRubrica);
              } else {
                return this.$refs.dadosAdiantamento.listaDeSubrubricas(solicitacao.idProjeto, solicitacao.idRubrica);
              }
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
              if (solicitacao.tipoReembolso === 0) {
                this.$set(this.rubricasSubrubricas.passagem, 'idSubrubrica', solicitacao.idSubrubrica);
              } else if (solicitacao.tipoReembolso === 1) {
                this.$set(this.rubricasSubrubricas.diaria, 'idSubrubrica', solicitacao.idSubrubrica);
              } else {
                this.$set(this.rubricasSubrubricas.adiantamento, 'idSubrubrica', solicitacao.idSubrubrica);
              }
            }
          })
          .then(() => solicitacaoReembolsoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
          })
          .then(() => {
            this.buscaDesabilitarBeneficiario();
            this.carregando = false;
          });
      },
      apenasIdaAlterado(apenasIda) {
        this.apenasIda = apenasIda;
      },
      listaDeRubricas(idProjeto) {
        if (!this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb) {
          return;
        }
        
        this.rubricasSubrubricas = {
          diaria: {
            idRubrica: '',
            idSubrubrica: '',
          },
          passagem: {
            idRubrica: '',
            idSubrubrica: '',
          },
          adiantamento: {
            idRubrica: '',
            idSubrubrica: '',
          },
        };

        return projetoServico
          .rubricas(idProjeto)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      download(arquivo) {
        solicitacaoReembolsoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download(); 
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {

    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Dados cadastrais
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-pagamento">
                  Dados para o pagamento
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-viagem">
                  Dados da viagem
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-diarias"
                   v-if="(!!$route.params.id && tipos.diaria) || !(!!$route.params.id)">
                  Diárias
                </a>
              </li>
              <li v-if="configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb">
                <a data-toggle="tab"
                   href="#tab-passagens"
                   v-if="(!!$route.params.id && tipos.passagem) || !(!!$route.params.id)">
                  Passagens
                </a>
              </li>
              <li v-if="configuracao.utilizarSolicitacaoAdiantamentoWeb">
                <a data-toggle="tab"
                   href="#tab-adiantamento"
                   v-if="(!!$route.params.id && tipos.adiantamento) || !(!!$route.params.id)">
                  Adiantamento
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoReembolso && ((!!$route.params.id && tipos.diaria) || !(!!$route.params.id))">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos-diaria">
                  Adicionar arquivos diária
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoReembolso && configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb && ((!!$route.params.id && tipos.passagem) || !(!!$route.params.id))">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos-passagem">
                  Adicionar arquivos passagem
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoReembolso && configuracao.utilizarSolicitacaoAdiantamentoWeb && ((!!$route.params.id && tipos.adiantamento) || !(!!$route.params.id))">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos-adiantamento">
                  Adicionar arquivos adiantamento
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoReembolso">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :solicitacao="solicitacao"
                                    :edicao="!!$route.params.id"
                                    :desabilitarBeneficiario="this.desabilitarBeneficiario"
                                    @projetoAlterado="listaDeRubricas">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-dados-pagamento" class="tab-pane">
                <div class="panel-body">
                  <dados-pagamento ref="dadosPagamento"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id">
                  </dados-pagamento>
                </div>
              </div>

              <div id="tab-dados-viagem" class="tab-pane">
                <div class="panel-body">
                  <dados-viagem ref="dadosViagem"
                                :solicitacao="solicitacao"
                                @apenasIdaAlterado="apenasIdaAlterado"
                                :edicao="!!$route.params.id">
                  </dados-viagem>
                </div>
              </div>

              <div id="tab-diarias" class="tab-pane">
                <div class="panel-body">
                  <diarias ref="dadosDiarias"
                           :solicitacao="solicitacao"
                           :tipos="tipos"
                           :motivos="motivos"
                           :rubricas="rubricas"
                           :rubrica-subrubrica="rubricasSubrubricas.diaria"
                           :edicao="!!$route.params.id"
                           v-if="(!!$route.params.id && tipos.diaria) || !(!!$route.params.id)">
                  </diarias>
                </div>
              </div>

              <div id="tab-passagens" class="tab-pane" v-if="configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb">
                <div class="panel-body">
                  <passagens ref="dadosPassagens"
                             :solicitacao="solicitacao"
                             :tipos="tipos"
                             :motivos="motivos"
                             :apenas-ida="apenasIda"
                             :rubricas="rubricas"
                             :rubrica-subrubrica="rubricasSubrubricas.passagem"
                             :edicao="!!$route.params.id"
                             v-if="(!!$route.params.id && tipos.passagem) || !(!!$route.params.id)">
                  </passagens>
                </div>
              </div>

              <div id="tab-adiantamento" class="tab-pane" v-if="configuracao.utilizarSolicitacaoAdiantamentoWeb">
                <div class="panel-body">
                  <adiantamento ref="dadosAdiantamento"
                                :solicitacao="solicitacao"
                                :tipos="tipos"
                                :motivos="motivos"
                                :rubricas="rubricas"
                                :rubrica-subrubrica="rubricasSubrubricas.adiantamento"
                                :edicao="!!$route.params.id"
                                v-if="(!!$route.params.id && tipos.adiantamento) || !(!!$route.params.id)">
                  </adiantamento>
                </div>
              </div>

              <div id="tab-adicionar-arquivos-diaria" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivosDiaria">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-adicionar-arquivos-passagem" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivosPassagem">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-adicionar-arquivos-adiantamento" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivosAdiantamento">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">Email do Beneficiário</label>

            <input type="text"
                   class="form-control"
                   id="documento"
                   v-model="documento"
                   data-vv-as="e-mail"
                   data-vv-name="documento"
                   maxlength="100"
                   v-caracteres-email
                   v-validate="'required|email'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'solicitacao-reembolso-estrangeiro' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button id="avancar"
                    type="button"
                    class="btn btn-primary"
                    @click="validarBeneficiario"
                    v-show="!mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar
              <i class="fa fa-arrow-right"></i>
            </button>

            <button type="button"
                    class="btn btn-default"
                    @click="mostrarFormulario = false, resetarComponente()"
                    v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="mostrarFormulario"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-estrangeiro/componentes/SolicitacaoReembolsoEstrangeiroForm.vue